var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { withMountWhenInView } from "@studiometa/js-toolkit";
import { Transition } from "../../primitives/index.js";
class Figure extends withMountWhenInView(Transition, {
  threshold: [0, 1]
}) {
  get target() {
    return this.$refs.img;
  }
  get src() {
    return this.$refs.img.src;
  }
  set src(value) {
    this.$refs.img.src = value;
  }
  mounted() {
    const { img } = this.$refs;
    if (!img) {
      throw new Error("[Figure] The `img` ref is required.");
    }
    if (!(img instanceof HTMLImageElement)) {
      throw new Error("[Figure] The `img` ref must be an `<img>` element.");
    }
    const { src } = img.dataset;
    if (this.$options.lazy && src && src !== this.src) {
      let tempImg = new Image();
      tempImg.addEventListener(
        "load",
        async () => {
          this.src = src;
          tempImg = null;
          this.enter();
        },
        { once: true }
      );
      tempImg.src = src;
    }
  }
}
__publicField(Figure, "config", {
  ...Transition.config,
  name: "Figure",
  refs: ["img"],
  options: {
    ...Transition.config.options,
    lazy: Boolean
  }
});
export {
  Figure
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
